import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { PageShell } from '../components/pages/PageShell';
import { ContentIntro } from '../components/pages/ContentIntro';
import { ContentBody } from '../components/pages/ContentBody';
import { ContentFaq } from '../components/pages/ContentFaq';
import { ContentCTA } from '../components/pages/ContentCTA';
import { RelatedPages } from '../components/pages/RelatedPages';
import { GalleryGrid } from '../components/pages/GalleryGrid';
import { ButtonLink } from '../components/ButtonLink';
import { contact, urls } from '../data/site';
import { galleryPhotos } from '../data/gallery';
import { guideContentPages, servicePages } from '../data/pageContent';
import type { PageContent, PageLink } from '../types/pageContent';
import { contentBreadcrumbs } from './ServiceContentPage';
function ContactDetails() {
  const cards = [{
    title: 'Call the shop',
    text: contact.phoneDisplay,
    href: contact.phoneHref,
    label: 'Call Motor City',
    Icon: PhoneIcon
  }, {
    title: 'Visit Brighton',
    text: `${contact.street}, ${contact.cityLine}`,
    href: urls.directions,
    label: 'Get Directions',
    Icon: MapPinIcon
  }, {
    title: 'Email',
    text: 'sales@motorcitytruckcollision.com',
    href: 'mailto:sales@motorcitytruckcollision.com',
    label: 'Email the shop',
    Icon: MailIcon
  }];
  return <section aria-label="Contact details" className="bg-paper py-14 md:py-20" data-id="element-541" data-mp="wwu42lfrw5re"><div className="mx-auto grid max-w-[1320px] gap-5 px-5 sm:px-8 lg:grid-cols-3 lg:px-12" data-id="element-542" data-mp="1kmy46itr5ndn">
    {cards.map(({
        title,
        text,
        href,
        label,
        Icon
      }) => <div key={title} className="flex min-w-0 flex-col border border-line bg-paper-bright p-7 md:p-8" data-id="element-543" data-mp="1pivikjlggjns"><Icon aria-hidden="true" className="h-6 w-6 text-brand" data-id="element-544" data-mp="1bnb01p9n23gw" /><h2 className="mt-5 font-display text-[32px] font-bold uppercase leading-none" data-id="element-545" data-mp="1gj8j43cadnxd">{title}</h2><p className="mt-4 break-words text-[17px] leading-relaxed text-steel" data-id="element-546" data-mp="5s32emniwqs">{text}</p><ButtonLink href={href} variant="outlineLight" className="mt-7 w-full text-[16px]" data-id="element-547" data-mp="54uzxbsh9wno">{label}</ButtonLink></div>)}
  </div></section>;
}
export function UtilityContentPage({
  page
}: {
  page: PageContent;
}) {
  const inquiry = ['hub', 'gallery', 'contact'].includes(page.kind);
  let links: PageLink[] = page.links || [];
  if (page.kind === 'hub' && !links.length) {
    const collection = /resource|guide/.test(page.id) ? guideContentPages : servicePages;
    links = collection.map(item => ({
      path: item.path,
      label: item.navLabel,
      description: item.description
    }));
  }
  const gallery = page.galleryImages || galleryPhotos.map(photo => ({
    ...photo
  }));
  const hasBody = Boolean(page.answer || page.sections?.length || page.note || page.checklist);
  return <PageShell data-id="element-548" data-mp="1e5wnhb8rwbil"><ContentIntro page={page} breadcrumbs={contentBreadcrumbs(page)} showActions={inquiry} data-id="element-549" data-mp="1e7pjzxpo9fcv" />
    {page.kind === 'contact' && <ContactDetails data-id="element-550" data-mp="38jnq3qsopv4j" />}
    {page.kind === 'gallery' && <GalleryGrid images={gallery} data-id="element-551" data-mp="38iclxpvbulcw" />}
    {links.length > 0 && <RelatedPages links={links} heading={page.kind === 'hub' ? page.navLabel : 'Next steps'} data-id="element-552" data-mp="34ic19nhmxdxe" />}
    {hasBody && <ContentBody page={page} withSidebar={inquiry} data-id="element-553" data-mp="qat9aqtg36j8" />}
    <ContentFaq faqs={page.faqs || []} data-id="element-554" data-mp="q8724sagut1j" /><RelatedPages links={page.related || []} data-id="element-555" data-mp="v94f8qgmcww6" />
    {inquiry && <ContentCTA data-id="element-556" data-mp="v7jkazqe7bxs" />}
  </PageShell>;
}